import { Button } from "primereact/button";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { Dispatch, SetStateAction } from "react";

type SearchBarProps = {
  globalFilterValue: string;
  setGlobalFilterValue: Dispatch<SetStateAction<string>>;
};

export default function SearchBar({
  globalFilterValue,
  setGlobalFilterValue,
}: SearchBarProps) {
  return (
    <>
      <IconField iconPosition="left">
        <InputIcon className="pi pi-search" />
        <InputText
          placeholder="Szukaj..."
          value={globalFilterValue}
          onChange={(e) => {
            setGlobalFilterValue(e.target.value);
          }}
        />
      </IconField>
      {globalFilterValue && (
        <Button
          onClick={() => setGlobalFilterValue("")}
          icon="pi pi-times"
        ></Button>
      )}
    </>
  );
}
